<div class="dx-card pre-press-accordion" id="accordion">
  <dx-accordion
    #accordion
    [dataSource]="[{ title: 'Prepress', item: {} }]"
    [collapsible]="true"
    [animationDuration]="300"
    [focusStateEnabled]="false"
    [hoverStateEnabled]="false"
    [selectedIndex]="-1"
    (onSelectionChanged)="onAccordionClick($event)"
  >
    <div *dxTemplate="let itemData of 'title'">
      <h3 [class.with-toggle]="showToggleButton">
        <span style="padding-left: 0.3em">Prepress</span>

        <!-- Toggle Button (nur anzeigen wenn showToggleButton true ist) -->
        <button
          *ngIf="showToggleButton"
          class="toggle-button"
          [class.active]="prepressEnabled"
          (click)="onTogglePrepress(); $event.stopPropagation()"
          [title]="prepressEnabled ? 'Disable Prepress' : 'Enable Prepress'"
        >
          <i [class]="prepressEnabled ? 'dx-icon-check' : 'dx-icon-plus'"></i>
        </button>
      </h3>
    </div>
    <div *dxTemplate="let itemData of 'item'">
      <div>
        <dx-form
          #prePressForm
          labelMode="floating"
          class="pre-press-form"
          [disabled]="!prepressEnabled"
        >
          <dxi-item
            itemType="group"
            [colCount]="6"
            [colCountByScreen]="{ xs: 1 }"
          >
            <!-- Print & Bind Section -->
            <dxi-item [colSpan]="6" [cssClass]="'pre-press-form-label'">
              <div class="sub-headline">
                <span>Print & Bind</span>
              </div>
            </dxi-item>

            <!-- Prep - Print Read PDF -->
            <dxi-item name="prepPrintReadPDF" [colSpan]="3">
              <div *dxTemplate="let data">
                <dx-select-box
                  stylingMode="filled"
                  [dataSource]="prepPrintDataSource"
                  [(value)]="selectedPrepPrint"
                  label="Prep"
                  displayExpr="displayValue"
                  [searchEnabled]="false"
                  style="caret-color: transparent"
                ></dx-select-box>
              </div>
            </dxi-item>

            <!-- Proof - Soft Proof -->
            <dxi-item name="proofSoftProof" [colSpan]="3">
              <div *dxTemplate="let data">
                <dx-select-box
                  stylingMode="filled"
                  [dataSource]="proofSoftDataSource"
                  [(value)]="selectedProofSoft"
                  label="Proof"
                  displayExpr="displayValue"
                  [searchEnabled]="false"
                  style="caret-color: transparent"
                ></dx-select-box>
              </div>
            </dxi-item>

            <!-- Component Section -->
            <dxi-item [colSpan]="6" [cssClass]="'pre-press-form-label'">
              <div class="sub-headline">
                <span>Component</span>
              </div>
            </dxi-item>

            <!-- Component Prep - Print Read PDF -->
            <dxi-item name="componentPrepPrintReadPDF" [colSpan]="3">
              <div *dxTemplate="let data">
                <dx-select-box
                  stylingMode="filled"
                  [dataSource]="componentPrepPrintDataSource"
                  [(value)]="selectedComponentPrepPrint"
                  label="Prep"
                  displayExpr="displayValue"
                  [searchEnabled]="false"
                  style="caret-color: transparent"
                ></dx-select-box>
              </div>
            </dxi-item>

            <!-- Component Proof - Soft Proof -->
            <dxi-item name="componentProofSoftProof" [colSpan]="3">
              <div *dxTemplate="let data">
                <dx-select-box
                  stylingMode="filled"
                  [dataSource]="componentProofSoftDataSource"
                  [(value)]="selectedComponentProofSoft"
                  label="Proof"
                  displayExpr="displayValue"
                  [searchEnabled]="false"
                  style="caret-color: transparent"
                ></dx-select-box>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </div>
    </div>
  </dx-accordion>
</div>
